import { useState } from "react";

const channels = [
  { label: "人物追踪", href: "#personas" },
  { label: "扒皮时间线", href: "#timeline" },
  { label: "身份疑点", href: "#doubts" },
  { label: "关系与焦点", href: "#relation" },
  { label: "话题热榜", href: "#topics" },
  { label: "网友FAQ", href: "#faq" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      {/* 顶部工具条 */}
      <div className="hidden md:flex items-center justify-between px-4 md:px-6 py-2 border-b border-background-200/60 bg-background-100/70 text-xs text-foreground-500">
        <div className="flex items-center gap-4 min-w-0">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-fire-line text-accent-600 w-4 h-4 flex items-center justify-center" />
            今日热词：反差黑料人物是谁
          </span>
          <span className="truncate">更新于 2026-09-06 12:00 · 持续追踪中</span>
        </div>
        <div className="flex items-center gap-3 whitespace-nowrap">
          <span className="inline-flex items-center gap-1">
            <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
            平均 6 分钟读完
          </span>
          <a href="#disclaimer" className="hover:text-primary-600 transition-colors">
            内容声明
          </a>
        </div>
      </div>

      {/* 主导航 */}
      <div className="flex items-center justify-between gap-4 px-4 md:px-6 h-16">
        <a href="#" className="flex items-center gap-2 shrink-0">
          <span className="w-8 h-8 rounded-md bg-primary-600 flex items-center justify-center text-background-50">
            <i className="ri-spy-line text-lg w-5 h-5 flex items-center justify-center" />
          </span>
          <span className="text-lg font-bold font-heading text-foreground-950 whitespace-nowrap">
            反差黑料
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {channels.map((c) => (
            <a
              key={c.href}
              href={c.href}
              className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50/70 rounded-md whitespace-nowrap transition-colors"
            >
              {c.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2 shrink-0">
          <div className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400 w-4 h-4 flex items-center justify-center" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="搜人物 / 话题"
              className="h-9 w-40 lg:w-52 rounded-md border border-background-200 bg-background-50 pl-9 pr-3 text-sm text-foreground-900 outline-none focus:border-primary-400 transition-colors placeholder:text-foreground-400"
            />
          </div>
          <button className="h-9 px-4 rounded-md bg-primary-600 text-background-50 text-sm whitespace-nowrap hover:bg-primary-700 transition-colors cursor-pointer">
            扒皮速查
          </button>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 cursor-pointer"
          aria-label="菜单"
        >
          <i className="ri-menu-line text-xl w-5 h-5 flex items-center justify-center" />
        </button>
      </div>

      {/* 移动端菜单 */}
      {open ? (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50 px-4 py-3 flex flex-col gap-1">
          {channels.map((c) => (
            <a
              key={c.href}
              href={c.href}
              onClick={() => setOpen(false)}
              className="px-3 py-2 text-sm text-foreground-700 hover:bg-primary-50 rounded-md transition-colors"
            >
              {c.label}
            </a>
          ))}
          <div className="relative mt-2">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400 w-4 h-4 flex items-center justify-center" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="搜人物 / 话题"
              className="h-9 w-full rounded-md border border-background-200 bg-background-50 pl-9 pr-3 text-sm outline-none focus:border-primary-400"
            />
          </div>
        </div>
      ) : null}
    </header>
  );
}